import React, { Component } from 'react';
import { formatDateTime, formatAmount } from 'src/Common/utils';
import Menu from './Menu';

const StatusBadge = ({ settled }) => {
    if (settled===null) {
        return (
            <span className="badge badge-default">Desconhecido</span>
        );
    }
    if (settled) {
        return (
            <span className="badge badge-success">Liquidado</span>
        );
    }

    return (
        <span className="badge badge-warning">Pendente</span>
    );
}


export default class TableRow extends Component {
    render() {
        const { createdAt, barcode, amount, dueDate, settled, settledAt } = this.props;
        return (
            <tr>
                <td>{formatDateTime(createdAt)}</td>
                <td>{barcode}</td>
                <td>{formatAmount(amount)}</td>
                <td>{formatDateTime(dueDate)}</td>
                <td>
                    <StatusBadge settled={settled} />
                </td>
                <td>{formatDateTime(settledAt)}</td>
            </tr>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Bills/TableRow.js